import './polyfill'

if (typeof window === 'undefined') {
  throw new TypeError('This code must be run in a browser environment.')
}

let maxRetries = 100

async function init() {
  if (window.electron) {
    const [windowModule, shortcutModule, clipboardModule, utilsModule, updaterModule] = await Promise.all([
      import('./windowManager'),
      import('./shortcutManager'),
      import('./clipboardManager'),
      import('./utilsManager'),
      import('./updaterManager'),
    ])

    window.WindowManager = new windowModule.default()
    window.ShortCutManager = new shortcutModule.default()
    window.ClipboardManager = clipboardModule.default
    window.UtilsManager = utilsModule.default
    window.UpdaterManager = updaterModule.default
    window.dispatchEvent(new Event('oyirpa-electron-sdk-ready'))
    console.log('%c Electron SDK initialization is complete', 'color: white; background-color: green;')
  }
  else {
    setTimeout(() => {
      maxRetries-- > 0 ? init() : console.warn('Electron SDK initialization failed: electron not found')
    }, 0)
  }
}

init()
